export const ForgotPassword = () => {
  return <>This is forgot password page</>;
};
